<div class="subscription-container">
  @if (subscriptionService.loading()) {
    <div class="loading-container">
      <p-progressSpinner class="loading-spinner"></p-progressSpinner>
      <p i18n="@@subscription.loading">Loading subscription data...</p>
    </div>
  } @else if (subscriptionService.data()) {
    <div class="subscription-content">
      <!-- Current Plan Section -->
      <p-card>
        <ng-template #title><ng-container i18n="@@subscription.currentPlan">Current Plan</ng-container></ng-template>
        <div class="plan-info">
          <div class="plan-detail">
            <span class="label" i18n="@@subscription.plan">Plan:</span>
            <span class="value">{{ subscriptionService.data()?.subscription?.plan_name || 'N/A' }}</span>
          </div>
          <div class="plan-detail">
            <span class="label" i18n="@@subscription.status">Status:</span>
            <span class="value status" [class]="subscriptionService.data()?.subscription?.status || ''">
              {{ subscriptionService.data()?.subscription?.status || 'N/A' }}
            </span>
          </div>
        </div>
      </p-card>

      <!-- Usage Section -->
      @if (subscriptionService.data()?.subscription?.current_usage) {
        <p-card>
          <ng-template #title><ng-container i18n="@@subscription.usage">Usage</ng-container></ng-template>
          <div class="usage-info">
            <div class="usage-period">
              <div class="usage-detail">
                <span class="label" i18n="@@subscription.periodStart">Period Start:</span>
                <span class="value">{{ formatDate(subscriptionService.data()?.subscription?.current_usage?.from_date) }}</span>
              </div>
              <div class="usage-detail">
                <span class="label" i18n="@@subscription.periodEnd">Period End:</span>
                <span class="value">{{ formatDate(subscriptionService.data()?.subscription?.current_usage?.to_date) }}</span>
              </div>
            </div>
            <div class="usage-metrics">
              @if (subscriptionService.data()?.subscription?.current_usage?.metrics) {
                @for (metric of subscriptionService.data()?.subscription?.current_usage?.metrics; track metric.metric_code) {
                  @if (metric.grouped_usage && metric.grouped_usage.length > 0) {
                    <p-accordion styleClass="metric-accordion">
                      <p-accordion-panel [value]="metric.metric_code || '0'">
                        <p-accordion-header>
                          <div class="metric-header">
                            <span class="metric-name">
                              {{ metric.metric_name || metric.metric_code }}:
                              {{ formatAmount(metric.amount_cents, subscriptionService.data()?.subscription?.current_usage?.currency) }}
                              ({{ metric.units || 0 }} <ng-container i18n="@@subscription.units">units</ng-container>)
                            </span>
                            <i class="pi pi-info-circle"
                               i18n-pTooltip="@@subscription.expandTooltip"
                               pTooltip="Expand to see detailed breakdown"
                               tooltipPosition="top"></i>
                          </div>
                        </p-accordion-header>
                        <p-accordion-content>
                          <div class="grouped-usage-list">
                            @for (group of metric.grouped_usage; track $index) {
                              <div class="grouped-item">
                                @if (group.filter_values && group.filter_values.length > 0) {
                                  <div class="group-labels">
                                    @for (filter of group.filter_values; track filter.key) {
                                      <span class="group-badge">{{ filter.key }}: {{ filter.value }}</span>
                                    }
                                  </div>
                                }
                                <div class="group-stats">
                                  <span><ng-container i18n="@@subscription.unitsLabel">Units:</ng-container> {{ group.units || 0 }}</span>
                                  <span><ng-container i18n="@@subscription.amountLabel">Amount:</ng-container> {{ formatAmount(group.amount_cents, subscriptionService.data()?.subscription?.current_usage?.currency) }}</span>
                                </div>
                              </div>
                            }
                          </div>
                        </p-accordion-content>
                      </p-accordion-panel>
                    </p-accordion>
                  } @else {
                    <div class="usage-detail metric-detail">
                      <span class="label">{{ metric.metric_name || metric.metric_code }}:</span>
                      <span class="value metric">
                        {{ formatAmount(metric.amount_cents, subscriptionService.data()?.subscription?.current_usage?.currency) }}
                        ({{ metric.units || 0 }} <ng-container i18n="@@subscription.units">units</ng-container>)
                      </span>
                    </div>
                  }
                }
              }

              <p-divider />

              <div class="usage-detail">
                <span class="label" i18n="@@subscription.totalAmount">Total Amount:</span>
                <span class="value metric">
                  {{ formatAmount(
                    subscriptionService.data()?.subscription?.current_usage?.total_amount_cents,
                    subscriptionService.data()?.subscription?.current_usage?.currency
                  ) }}
                </span>
              </div>
              @if (subscriptionService.data()?.subscription?.wallet) {
                <div class="usage-detail">
                  <span class="label" i18n="@@subscription.prepaidAmount">Prepaid Amount:</span>
                  <span class="value metric">
                    {{ prepaidCurrencySymbol }}{{ (subscriptionService.data()?.subscription?.wallet?.balance_dollars || 0).toFixed(2) }}
                  </span>
                </div>
              }
            </div>

            <p-divider />

            <div class="usage-total">
              <div class="total-row">
                <span class="total-label" i18n="@@subscription.amountDue">Amount Due:</span>
                <span class="total-value">{{ getAmountDue() }}</span>
              </div>
              @if (subscriptionService.data()?.subscription?.portal_url) {
                <p-button
                  i18n-label="@@subscription.customerPortal"
                  label="Customer Portal"
                  icon="pi pi-external-link"
                  (onClick)="openPortal()"
                  [outlined]="true"
                  size="small"
                />
              }
            </div>
          </div>
        </p-card>
      }
    </div>
  } @else {
    <p-card>
      <p i18n="@@subscription.empty">No subscription data available</p>
    </p-card>
  }
</div>
